<template>
  <div>
    <div class="row">
      <div class="col-8 offset-2">
        <div class="my-3">
          <campaign-id-search
            @on-campaign-found="handleCampaignFound"
            @on-search="handleOnSearch"
          ></campaign-id-search>
        </div>
        <div
          style="background-color: white; padding: 16px;"
          class="mb-3"
          v-if="campaign"
        >
          <campaign-overview
            :id="campaign.id"
            :agency="campaign.agency.displayName || campaign.agency.title"
            :packageTitle="campaign.package.title"
            :property="campaign.property ? campaign.property.title : 'N/A'"
            :bookedBy="campaign.bookedBy ? campaign.bookedBy.firstName + ' ' + campaign.bookedBy.lastName : null"
            :bookedAt="campaign.createdAt"
            :startDate="campaign.startDate"
            :endDate="campaign.endDate"
            :status="campaign.status"
            :associatedCampaignId="campaign.associatedCampaignId"
            :type="campaign.type"
          ></campaign-overview>
        </div>

        <ad-listing-form
          v-if="campaign && hasProductResponse"
          :campaignId="campaign.id"
          :campaignType="campaign.type"
        ></ad-listing-form>
        <div v-else-if="campaign && !hasProductResponse">
          <p style="text-align: center; color: #dc3545;">
            No Signifi ad listing found for this campaign.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CampaignIdSearch from '../../../components/CampaignTools/CampaignIdSearch.vue';
import CampaignOverview from '../../../components/CampaignTools/CampaignOverview.vue';
import AdListingForm from '../../../components/CampaignTools/CampaignAdListing/AdListingForm.vue';

export default {
  components: {
    CampaignIdSearch,
    CampaignOverview,
    AdListingForm,
  },
  data() {
    return {
      progressBar: {
        progress: 0,
        label: 'Saving changes...',
        state: 'loading',
        visible: false,
      },
      adDetails: null,
      campaign: null,
    };
  },
  computed: {
    hasProductResponse() {
      return this.campaign && this.campaign.signifiProductResponse;
    },
  },
  methods: {
    handleOnSearch() {
      this.campaign = null;
    },
    handleCampaignFound(campaign) {
      console.log("🚀 ~ campaign:", campaign.type)
      this.campaign = campaign;
    },
  },
};
</script>
